(function() {
  const initCustomTabsWithProducts = () => {
    const customTabs = document.querySelectorAll('.custom-tabs__image-wrapper');

    customTabs.forEach((tab) => {
      tabClick(tab);
    });

    function tabClick(tab) {
      tab.addEventListener('click', function() {
        const tabImage = tab.querySelector('img');
        if(tabImage) {
          cleanActived(tab);
          getImageSrc(tabImage);
          getHeading(tab);
        }
      });
    }

    function getImageSrc(tabImage) {
      const tabImageSrc = tabImage.getAttribute('src');
      const tabImageSrcset = tabImage.getAttribute('srcset');
      
      if (tabImageSrc) {
        changeImage(tabImageSrc, tabImageSrcset, tabImage);
      }
    }

    function changeImage(tabImageSrc, tabImageSrcset, tabImage) {
      const parent = tabImage.closest('.twp__content-item');
      const activedImageWrapper = parent.querySelector('.actived-tab__image');

      if (activedImageWrapper) {
        const activedImage = activedImageWrapper.querySelector('img');

        if (activedImage) {
          // Pega o width atual do SRC ativo
          const currentSrc = activedImage.getAttribute('src');
          const urlObj = new URL(currentSrc, window.location.origin);
          const currentWidth = urlObj.searchParams.get('width');

          // Substitui apenas a URL base e mantém o width atual
          const newUrlObj = new URL(tabImageSrc, window.location.origin);
          if (currentWidth) {
              newUrlObj.searchParams.set('width', currentWidth);
          }

          // Atualiza SRC e SRCSET
          activedImage.setAttribute('src', newUrlObj.toString());
          if (tabImageSrcset) {
              activedImage.setAttribute('srcset', tabImageSrcset);
          }

          activeSelectedTab(tabImage);
        }
      }
    }

    function activeSelectedTab(tabImage) {
      const wrapper = tabImage.closest('.custom-tabs__image-wrapper');
      if(wrapper) {
        wrapper.classList.add('custom-tabs__image-wrapper--actived');
      }
    }

    function cleanActived(tab) {
      const parent = tab.closest('.custom-tabs__images');

      if(parent) {
        const tabs = parent.querySelectorAll('.custom-tabs__image-wrapper');
        if(tabs.length > 0) {
          tabs.forEach((tab) => {
            tab.classList.remove('custom-tabs__image-wrapper--actived');
          });  
        }
      }
    }

    function getHeading(tab) {
      const image = tab.querySelector('.custom-tabs__image');
      if(image) {
        const heading = image.getAttribute('data-heading');

        const sectionWrapper = tab.closest('.twp__content-item');
        if(sectionWrapper) {
          const activedHeading = sectionWrapper.querySelector('.actived-tab__heading');
          if(heading) {
            activedHeading.textContent = heading;
          } else {
            activedHeading.textContent = '';
          }
        }
      }
    }
  }

  initCustomTabsWithProducts();

  document.addEventListener("shopify:section:load", function () {
    initCustomTabsWithProducts();
  });
})();